import { render, staticRenderFns } from "./ModalDraftWriting.vue?vue&type=template&id=2e5bb39b&scoped=true&"
import script from "./ModalDraftWriting.vue?vue&type=script&lang=js&"
export * from "./ModalDraftWriting.vue?vue&type=script&lang=js&"
import style0 from "./ModalDraftWriting.vue?vue&type=style&index=0&id=2e5bb39b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5bb39b",
  null
  
)

export default component.exports